export default __webpack_public_path__ + "static/media/dnyou.c96df628.png";